import { PrimaryFullScreenSpinner, TabLink, TabLinkContainer } from "@repo/ui";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { Suspense } from "react";
import { AdminPageContainer } from "~/components/layout/AdminPageContainer";
import { AdminPageHeader } from "~/components/layout/AdminPageHeader";
import { opsHead } from "~/head";

export const Route = createFileRoute("/__auth/transaction-monitoring")({
  head: () => opsHead("Transaction Monitoring"),
  beforeLoad({ location }) {
    if (location.pathname === "/transaction-monitoring") {
      throw redirect({
        to: "/transaction-monitoring/findings",
        search: location.search,
        hash: location.hash,
      });
    }
  },
  component: () => (
    <Suspense fallback={<PrimaryFullScreenSpinner />}>
      <View />
    </Suspense>
  ),
});

function View() {
  return (
    <AdminPageContainer testId="admin-transaction-monitoring">
      <AdminPageHeader
        title="Transaction Monitoring"
        subtitle="Review flagged findings and recent evaluation activity."
      />
      <TabLinkContainer className="mb-6" size="sm">
        <TabLink to="/transaction-monitoring/findings" title="Findings" />
        <TabLink to="/transaction-monitoring/evaluations" title="Evaluations" />
      </TabLinkContainer>
      <Outlet />
    </AdminPageContainer>
  );
}
